import React from 'react';
import SendNotificationModal from './Components/SendNotificationModal/SendNotificationModal';
import './EmailTemplateComposer.css';

const EmailTemplateComposer = (props: any) => {
  return (
    <div className="cp-dashboard-container">
      <SendNotificationModal />
    </div>
  );
};

export default EmailTemplateComposer;
